(function() {
  const modal = document.getElementById('find-my-shade-modal');
  const dropdownButton = document.getElementById('shade-select');
  const dropdownContent = document.getElementById('shade-dropdown-content');
  const result = modal?.querySelector('.find-my-shade-modal__result');
  const shadeNum = modal?.querySelector('.js-powder-shade');
  const selectedText = modal?.querySelector('.vp__dropdown-selected');
  const selectedSwatch = modal?.querySelector('.js-selected-swatch');
  const resultSwatch = modal?.querySelector('.js-result-swatch');
  const variantInput = modal?.querySelector('.js-find-my-shade-variant-id');
  const priceDisplay = modal?.querySelector('.js-find-my-shade-powder-price');

  if (!modal || !dropdownButton || !dropdownContent || !result) return;
  
  // Open modal trigger
  document.addEventListener('click', e => {
    if (e.target.closest('[data-find-my-shade-trigger]')) {
      modal.show?.() || modal.setAttribute('open', 'true');
    }
  });

  // Toggle dropdown
  dropdownButton.addEventListener('click', () => {
    const isExpanded = dropdownButton.getAttribute('aria-expanded') === 'true';
    dropdownButton.setAttribute('aria-expanded', !isExpanded);
    dropdownContent.hidden = isExpanded;
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', e => {
    if (!e.target.closest('.find-my-shade-dropdown')) {
      dropdownButton.setAttribute('aria-expanded', 'false');
      dropdownContent.hidden = true;
    }
  });

  // Handle option selection
  dropdownContent.addEventListener('change', e => {
    const radio = e.target;
    if (radio.type !== 'radio') return;
    
    const option = radio.closest('.vp__dropdown-option');
    const powder = option?.dataset?.powder;
    const powderVariantId = option?.dataset?.powderVariantId;
    const powderPrice = option?.dataset?.powderPrice;
    const powderSwatch = option?.dataset?.powderSwatch;
    const label = option?.querySelector('.vp__dropdown-label');
    const swatch = option?.querySelector('.vp__dropdown-swatch');
    
    if (label && selectedText) {
      selectedText.textContent = label.textContent;
    }
    
    if (swatch && selectedSwatch) {
      const swatchBg = swatch.style.getPropertyValue('--swatch-background');
      if (swatchBg) {
        selectedSwatch.style.setProperty('--swatch-background', swatchBg);
      }
    }
    
    // Set powder swatch for result
    if (powderSwatch && powderSwatch !== 'null' && resultSwatch) {
      resultSwatch.style.setProperty('--swatch-background', powderSwatch);
    }
    
    if (powder) {
      shadeNum.textContent = powder;
      result.hidden = false;
    }

    if (powderVariantId && variantInput) {
      variantInput.value = powderVariantId;
    }

    if (powderPrice && priceDisplay) {
      const formattedPrice = (parseInt(powderPrice, 10) / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      priceDisplay.textContent = formattedPrice;
    }
    
    // Close dropdown after selection
    dropdownButton.setAttribute('aria-expanded', 'false');
    dropdownContent.hidden = true;
  });
})();
